import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }        from '../shared/shared.module';
import { StatementsComponent } from './statements.component';
import { StatementsService }   from './statements.service';
import { StatementsStates }    from './statements.states';
import { TableModule }         from '../table/table.module';

@NgModule({
  declarations: [
    StatementsComponent
  ],
  entryComponents: [
    StatementsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: StatementsStates })
  ],
  providers: [
    StatementsService
  ]
})
export class StatementsModule {}
